export default __webpack_public_path__ + "static/media/register_1.9fd1b74d.jpg";